import { InsuranceFormData } from '@/features/dashboard/insurances/schemas/insuranceSchema.ts';
import { InsuranceWebDto } from '@/features/dashboard/insurances/types/InsuranceWebDto.ts';

export const insuranceMapper = {
  fromFormToDto(form: InsuranceFormData): InsuranceWebDto {
    const description = form.description?.trim();
    return {
      id: null,
      name: form.name.trim(),
      description: description ? description : null,
    };
  },

  fromDtoToForm(dto: InsuranceWebDto): InsuranceFormData {
    return {
      name: dto.name,
      description: dto.description ?? '',
    };
  },
};
